var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-link--primary flex items-center font-bold text-sm leading-3.5",attrs:{"href":_vm.qr && _vm.qr.toDataURL(),"download":"ahaslides-qrcode.png"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }